import cn from 'classnames'
import { FC, useCallback } from 'react'

import { IToggleItemProps } from './models/toggleItemProps'

import styles from './ToggleItem.module.scss'

export const ToggleItem: FC<IToggleItemProps> = ({
  buttonClassName,
  value,
  isActive,
  isDisabled = false,
  onClick,
}) => {
  const handleClick = useCallback(() => {
    if (isDisabled) {
      return
    }

    onClick({
      value,
      isActive: !isActive,
      isDisabled,
    })
  }, [onClick, value, isActive, isDisabled])

  return (
    <div
      className={cn(styles.quarterItem, buttonClassName, {
        [styles.quarterItem__disabled]: isDisabled,
        [styles.quarterItem__clickable]: !isDisabled,
        [styles.quarterItem__active]: isActive,
      })}
      onClick={handleClick}
    >
      {`${value}`}
    </div>
  )
}
